var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_505_1",
    "data-name": "Component 505 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61977",
    "data-name": "Path 61977",
    d: "M9.182,8.273h3.636V5.545h2.727L11,1,6.455,5.545H9.182Zm-.909.909H5.545V6.455L1,11l4.545,4.545V12.818H8.273ZM21,11,16.455,6.455V9.182H13.727v3.636h2.727v2.727Zm-8.182,2.727H9.182v2.727H6.455L11,21l4.545-4.545H12.818Z",
    transform: "translate(-1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.d1d86df41806922fe7cf70025559fd04.svg";
export { ForwardRef as ReactComponent };